import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';

/**
 * Протермінований JWT (у нас 24 години) інакше лишає користувача на зламаній сторінці:
 * кожен запит тихо повертає 401, дані не оновлюються, і побачити причину можна лише в DevTools.
 * Реєструється ПІСЛЯ authInterceptor.
 */

/** На цих ендпоінтах 401 означає «невірний пароль», а не протермінований сеанс. */
const PUBLIC_AUTH_PATHS = ['/auth/sign-in', '/auth/sign-up', '/auth/sign/social'];

export const authErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  return next(req).pipe(
    catchError((error: unknown) => {
      const isPublicAuthCall = PUBLIC_AUTH_PATHS.some(path => req.url.includes(path));

      // 403 навмисно не чіпаємо: «немає прав» — це не «сеанс скінчився».
      // isAuthenticated() боронить від циклу редиректів, коли сховище вже почищене.
      if (
        error instanceof HttpErrorResponse &&
        error.status === 401 &&
        !isPublicAuthCall &&
        authService.isAuthenticated()
      ) {
        authService.signOut();
        router.navigate(['/login'], {
          queryParams: { reason: 'session-expired', returnUrl: router.url },
        });
      }

      return throwError(() => error);
    })
  );
};
